import { useContext } from 'react'

import { PrebidModulesContext } from 'features/globalSetup/contexts/PrebidModulesContext'
import { GeneralCommonFormContainer } from 'features/globalSetup/forms/Prebid/Modules/GeneralCommonFormContainer'
import {
  GeneralPaapiForm,
  isPAAPIModule,
} from 'features/globalSetup/forms/Prebid/Modules/GeneralPaapiForm'

export const GeneralTab = (): React.JSX.Element => {
  const { workspacePrebidModule } = useContext(PrebidModulesContext)

  if (!workspacePrebidModule) {
    throw Error('WorkspacePrebidModule should be accessible')
  }

  const {
    prebidModule: { name },
  } = workspacePrebidModule

  if (isPAAPIModule(name)) {
    return <GeneralPaapiForm />
  } else {
    return <GeneralCommonFormContainer />
  }
}
